import { CSSProperties } from 'react';
import PrimaryButton from '../PrimaryButton/PrimaryButton';
import Images from '../../Images';
import { Dialog, DialogContent } from '../Dialog';

interface Props {
  isShow: boolean;
  onHide: () => void;
  messageText: string;
  titleText: string;
  onOkay: () => void;
  titleClass?: string;
}

function handleGeneralErroMessageOnOkay(onHide: () => void, onOkay: () => void) {
  onHide();
  if (onOkay) {
    onOkay();
  }
}

const messageContainerStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
};

const imageStyle: CSSProperties = {
  height: '8rem',
  width: '8rem',
  margin: '1.4rem',
};

export const GeneralErrorMessage = ({
  isShow,
  onHide,
  messageText,
  titleText,
  onOkay,
  titleClass,
}: Props): JSX.Element => (
  <Dialog
    open={isShow}
    onOpenChange={(isOpen) => {
      if (!isOpen) {
        handleGeneralErroMessageOnOkay(onHide, onOkay);
      }
    }}
  >
    <DialogContent
      className='w-[min(95vw,560px)] rounded-[0.6rem] border-0 bg-white p-0 text-[1.6rem] shadow-[0_14px_34px_rgba(0,0,0,0.2)]'
      overlayClassName='bg-black/50'
    >
      <div className='relative flex justify-center px-[2.6rem] pb-[1.2rem] pt-[2.4rem]'>
        <button
          type='button'
          aria-label='Close'
          className='absolute right-[1rem] top-[0.7rem] flex h-[2.8rem] w-[2.8rem] items-center justify-center rounded-full border-0 bg-transparent p-0 text-[2.4rem] leading-none text-[#242424] outline-none focus:outline-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#45A8E4] focus-visible:ring-offset-2'
          onClick={onHide}
        >
          x
        </button>
        <div className={`generalDialogTitle ${titleClass ?? ''}`}>{titleText || `There's a Problem`}</div>
      </div>

      <div className='px-[2.6rem] pb-[2.6rem]'>
        <div style={messageContainerStyle}>
          <div>
            <img style={imageStyle} src={Images.backpackPatch} alt='Broken backpack indicating error' />
          </div>
          {messageText && (
            <span className='ModalDialogText generalErrorMessage' dangerouslySetInnerHTML={{ __html: messageText }} />
          )}
        </div>
        <div style={{ textAlign: 'center', padding: '2em', verticalAlign: 'middle' }}>
          <PrimaryButton onClick={() => handleGeneralErroMessageOnOkay(onHide, onOkay)}>Okay</PrimaryButton>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);
